import { NudosHoverText, NudosTextInput } from '../../../../../../../components/NudosComponents';
import { IShipmentGroupData } from '../../../../../../../types/orders';
import { getShipmentDestinationText } from '../../../../../../../utils/orders';

import './ShipmentsCostsSection.scss';

interface ShipmentCostsInputProps {
  index: number;
  shipmentGroup: IShipmentGroupData;
}
const ShipmentCostsInput = ({ index, shipmentGroup }: ShipmentCostsInputProps) => {
  const destinationText = getShipmentDestinationText(shipmentGroup?.destination);
  const label = `Envío ${index + 1}${destinationText ? ` - ${destinationText}` : ''}`;
  const value = `$${shipmentGroup?.price?.valueUsd || 0} USD`;

  return (
    <div className="shipmentInputContainer">
      <NudosHoverText customClassName="shipmentInputLabel" text={label} charactersLimit={27} onlyIfTruncated />
      <NudosTextInput componentSize="w120" placeholder={value} defaultValue={value} isDeactivated isFilled={false} />
    </div>
  );
};

const ShipmentsCostsSection = ({ shipmentGroupsData }: { shipmentGroupsData: IShipmentGroupData[] }) => {
  return (
    <div className="shipmentsCostsSection">
      <h3 className="sectionTitle">Costos de envíos</h3>
      <div className="costsByShipments">
        {shipmentGroupsData?.map((shipmentGroup, index) => (
          <ShipmentCostsInput
            key={`shipmentCost-${index}-${shipmentGroup?.id}`}
            index={index}
            shipmentGroup={shipmentGroup}
          />
        ))}
      </div>
    </div>
  );
};

export default ShipmentsCostsSection;
